import { useState } from "react";
import { useLocation } from "react-router-dom";
import { getDetails, postDetails } from "../services/http/http.service";
import { hideLoader, showLoader } from "../store/Loader/loader.slice";
import { setPageData, setPageNumber } from "../store/pageData/pageData.slice";
import { useAppDispatch, useAppSelector } from "../store/storeRequests";
import APIList from "../utils/constants/APIList";
import { APIResponseCodes } from "../utils/constants/keys.constants";
import StoreSelectors from "../utils/constants/StoreSelectors.constants";
import { NavList } from "../utils/constants/navigation";

const usePagination = ({ items, from, perPageResults }: { items: Array<any>; from?: "marketplace" | "production" | "live" | "uatorders" | "prodorders" | "access" | "invoice"; perPageResults?: number }) => {

  const { access } = useAppSelector(StoreSelectors.USER_STATE)

  const location = useLocation()
  const dispatch = useAppDispatch();
  const [itemOffset, setItemOffset] = useState(0);
  const { searchString, pageNumber, filterName, apiType } = useAppSelector(StoreSelectors.PAGE_STATE);

  let itemsPerPage = perPageResults || 5;

  let currentItems = []
  let pageCount = 0

  if (items !== null && typeof items !== 'undefined') {
    currentItems = items.length > 0 ? items.slice(0, 0 + itemsPerPage) : items;
    pageCount = Math.ceil(items.length / itemsPerPage);
  }

  if (from === 'access') {
    let newOffset = (itemOffset === 0 || itemOffset === -1) ? 0 : itemOffset
    let start = newOffset * itemsPerPage
    currentItems = items.slice(start, (newOffset + itemsPerPage) + start)
    pageCount = Math.ceil(items.length / itemsPerPage)
  }

  // Invoke when user click to request another page.
  const handlePageClick = async (event: any) => {
    dispatch(setPageData([]));
    let newOffset = event.selected - 1

    try {
      document.getElementsByClassName("scrollTo")[0].scrollIntoView({ behavior: "smooth" });
    } catch (error) {
      newOffset = event.selected - 1
    }

    dispatch(showLoader("Getting APIs..."));
    dispatch(setPageNumber(event.selected));

    if (from === "marketplace") {
      const isFiltered = filterName && filterName.toLowerCase() !== "all";
      const payload = isFiltered
        ? {
            search: searchString,
            page_no: event.selected + 1,
            group_type: filterName.toLowerCase() === 'read only' ? 'e-cas' : filterName.toLowerCase(),
          }
        : {
            search: searchString,
            page_no: event.selected + 1
          };
      const apiUrl = isFiltered ? APIList.FILTER_BY_TYPE : APIList.GET_GROUPS;
      console.log("PAGINATION PAYLOAD", payload);
      console.log("PAGINATION API URL", apiUrl);
      
      const response = await postDetails(apiUrl, payload, () => handlePageClick(event))
      if (response.statusCode === APIResponseCodes.SUCCESS) {
        dispatch(setPageData(response.data));
        newOffset = event.selected - 1
        currentItems = response.data.groups.length !== 0 ? response.data.groups.slice(newOffset, (newOffset + itemsPerPage)) : response.data.groups
        pageCount = Math.ceil(response.data.groups.length / itemsPerPage);
      }
    }

    if (location.pathname.includes(NavList.API_LISTING_PRODUCTION)) {
      const payload = {
        page_no: event.selected + 1,
        category: filterName.toLowerCase() === 'all' ? '' : filterName.toLowerCase(),
        env: apiType,
      }
      const response = await postDetails(APIList.GET_FILTERED_PROD_APIS, payload, () => handlePageClick(event));

      if (response.statusCode === APIResponseCodes.SUCCESS) {
        dispatch(setPageData(response.data));
        newOffset = event.selected - 1
        currentItems = response.data.resApiList.length > 0 ? response.data.resApiList.slice(newOffset, (newOffset + itemsPerPage)) : response.data.resApiList
        pageCount = Math.ceil(response.data.resApiList.length / itemsPerPage);
      }
    }

    if (location.pathname.includes(NavList.API_LISTING_LIVE)) {
      const response = await getDetails(`${APIList.GET_ALL_LIVE_APIS}?category=${filterName.toLowerCase() === 'all' ? '' : filterName.toLowerCase()}&page_no=${event.selected + 1}&env=${apiType}`, () => handlePageClick(event));
      if (response.statusCode === APIResponseCodes.SUCCESS) {
        dispatch(setPageData(response.data));
        newOffset = event.selected - 1
        currentItems = response.data.resApiList.length > 0 ? response.data.resApiList.slice(newOffset, (newOffset + itemsPerPage)) : response.data.resApiList
        pageCount = Math.ceil(response.data.resApiList.length / itemsPerPage);
      }
    }

    if (from === 'uatorders' && access.hasProdAccess) {
      const payload = {
        page_no: event.selected + 1
      }
      const response = await postDetails(APIList.GET_ALL_ORDERS, payload, () => handlePageClick(event));
      if (response.statusCode === APIResponseCodes.SUCCESS) {
        dispatch(setPageData(response.data));
        newOffset = event.selected - 1;
        currentItems = response.data.groupList.length > 0 ? response.data.groupList.slice(newOffset, (newOffset + itemsPerPage)) : response.data.groupList
        pageCount = Math.ceil(response.data.groupList.length / itemsPerPage);
      }
    }

    if (from === 'prodorders' && access.hasProdAccess) {
      const payload = {
        page_no: event.selected + 1
      }
      const response = await postDetails(APIList.GET_ALL_PROD_ORDERS, payload, () => handlePageClick(event));
      if (response.statusCode === APIResponseCodes.SUCCESS) {
        dispatch(setPageData(response.data));
        newOffset = event.selected - 1;
        currentItems = response.data.resApiList.length > 0 ? response.data.resApiList.slice(newOffset, (newOffset + itemsPerPage)) : response.data.resApiList
        pageCount = Math.ceil(response.data.resApiList.length / itemsPerPage);
      }
    }

    if (from === 'invoice') {
      const response = await getDetails(APIList.GET_INVOICES + `?page_no=${event.selected + 1}`, () => handlePageClick(event));
      if (response.statusCode === APIResponseCodes.SUCCESS) {
        dispatch(setPageData(response.data));
        newOffset = event.selected - 1
        currentItems = response.data.resApiList.length > 0 ? response.data.resApiList.slice(newOffset, (newOffset + itemsPerPage)) : response.data.resApiList
        pageCount = Math.ceil(response.data.resApiList.length / itemsPerPage);
      }
    }

    from === 'access' ? setItemOffset(event.selected) : setItemOffset(newOffset)
    dispatch(hideLoader());
  };

  return { currentItems, pageCount, itemsPerPage, pageNumber, itemOffset, handlePageClick, setItemOffset };
};

export default usePagination;
